__turbopack_context__.v({
  "top": "HeaderNavigation-module__PuGvfa__top",
});
